import axios from 'axios';
import config from '../config';
import { OnboardDeviceLogsArchive, PostOnboardDeviceLogsArchiveRequest } from '../interfaces';

export const postOnboardDeviceLogsArchive = (
    deviceId: string,
    request: PostOnboardDeviceLogsArchiveRequest,
): Promise<OnboardDeviceLogsArchive> => {
    const url = `${config.API_URL}/onboard-devices/${deviceId}/logs/archive`;

    return axios.post(url, request).then((response: any) => {
        return response.data;
    });
};
